import { asField, BasicText } from 'informed';
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';

import { ButtonSecondary } from 'Buttons';

import InputGroup from './InputGroup';

import './styles/formFieldStyles.css';
import '../Buttons/styles/buttonStyles.css';

const PasswordInput = asField((props) => {
  const { i18n, ...rest } = props;

  const [isPasswordShown, setIsPasswordShown] = useState(false);

  const toggleShow = () => setIsPasswordShown(!isPasswordShown);

  const { field, fieldState } = props;
  const { error, value } = fieldState;

  const strings = {
    hiddenDescription: i18n.hiddenDescription(),
    hideButtonText: i18n.hideButtonText(),
    showButtonText: i18n.showButtonText(),
    shownDescription: i18n.shownDescription(),
  };

  return (
    <Fragment>
      <InputGroup>
        <BasicText
          {...rest}
          aria-invalid={!!error}
          autoComplete="off"
          className={`custom-text-input ${
            value && !error ? 'success' : value && error && 'error'
          }`}
          id={field}
          type={isPasswordShown ? 'text' : 'password'}
        />
        <ButtonSecondary
          aria-label={
            isPasswordShown
              ? strings.shownDescription
              : strings.hiddenDescription
          }
          className="button-secondary dt-button"
          onClick={toggleShow}
        >
          {isPasswordShown ? strings.hideButtonText : strings.showButtonText}
        </ButtonSecondary>
      </InputGroup>
      {error && <small className="text-red-3">{error}</small>}
    </Fragment>
  );
});

PasswordInput.propTypes = {
  i18n: PropTypes.shape({
    hiddenDescription: PropTypes.func.isRequired,
    hideButtonText: PropTypes.func.isRequired,
    showButtonText: PropTypes.func.isRequired,
    shownDescription: PropTypes.func.isRequired,
  }).isRequired,
};

export default PasswordInput;
